<template>
  <div>
    <div v-if="showLoading" class="loadingComponent-loading-position">
      <v-progress-circular :size="70" :width="7" color="white" indeterminate>
      </v-progress-circular>
    </div>
  </div>
</template>
<style>
.loadingComponent-loading-position {
  height: 100%;
}

.v-progress-circular {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
}
</style>
<script>
export default {
  props: {
    showLoading: Boolean,
  },
};
</script>
